/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContractParamTemplateRentDrupoz { 
    contractParamTemplateId: number;
    drupozKod: number;
    katuzeKod: number;
    priceFromAcreage?: number | null;
    pricePercentFromAveragePrice?: number;
    pricePercentFromParcelPrice?: number;
    valorizationFromAcreage?: number | null;
    valorizationPercentFromAveragePrice: number;
    valorizationPercentFromParcelPrice: number;
    valorizationPercentageFromAcreage?: number | null;
}

